// extracted by mini-css-extract-plugin
export default {"wrapper":"C2C_wrapper__ppGhg","input":"C2C_input__2rv62"};